<template>
	<v-row
		justify = "center"
		align   = "center"
	>
		<v-col
			xl 	 = "8"
			lg 	 = "10"
			md   = "10"
			sm 	 = "10"
			xs 	 = "12"
			cols = "12"
		>
			<v-card outlined>
				<v-card-title
					class = "body-2 secondary pa-1 white--text"
				>	
					<v-icon 
						small 
						color  = "white"
						class  = "ml-1"
						@click = "$router.back()"
					>
						mdi-arrow-left-circle
					</v-icon>

					<v-spacer></v-spacer>
					<v-icon
						x-small
						color  = "white"
						v-text = "'mdi-file'"
						class  = "mx-2"
					></v-icon>
					<span 
						v-text = "$ml.get('lists')"
					></span>
					
					<v-spacer></v-spacer>
					
				</v-card-title>
				<v-card-text
					class = "pa-1"
				>
					<v-row
						dense
					>
						<v-col 
							xl   = "2"
							lg   = "2"
							md   = "2"
							sm   = "3"
							xs   = "3"
							cols = "3"
							v-show = "show.add_list"
							
						>
							<v-card >
								<v-card-title
									class = "pa-1 pl-1 secondary body-2 white--text"
								>	
									<v-icon
										x-small
										color = "white"
										class = "mx-1"
									>
										mdi-form-select
									</v-icon>
									{{ $ml.get('options') }} 
								</v-card-title>
								<v-card-text 
									class = "pa-1 pt-0"
								>
										
									<v-list dense>
										<v-list-item-group
										 	
										>
											<template
												v-for = "(btn_option, btn_index) of option_lists"
												v-if  = "btn_option.enable"
											>	
												<v-card 
													outlined 
													:color  = "btn_option.color"
													class   = "mt-1"
												>
												<v-list-item 
													:key   = "btn_index"	
													@click = "redirect(btn_option.btn_action, btn_option.key)"

												>
													<v-list-item-icon
												 		class = "mx-0"
												 	>
										            	<v-icon 
										            		small
										            		color  = "white"
										            		v-text = "btn_option.icon"
										            	></v-icon>
										          	</v-list-item-icon>	
													<v-list-item-title
														class  = "white--text"
														v-text = "btn_option.title"
													></v-list-item-title>
												</v-list-item>
											</v-card>
											</template>
										</v-list-item-group>
									</v-list>
								</v-card-text>
							</v-card>
						</v-col>
						<v-col>
							<v-toolbar
						    		
						    		dense
						    		height = "25"
						    		class  = "secondary"
						    	>
						    	<v-toolbar-title 
						    		class = "body-2 white--text"
						    	>
						    		<v-icon
										small
										color = "white"
										class = "mr-1"
									>
										mdi-view-list
									</v-icon>
						    		{{ $ml.get('registered_lists') }}
						    	</v-toolbar-title>
						    </v-toolbar>
								
							<v-divider></v-divider>
							<v-data-table
								dense
							    fixed-body
							    fixed-header
								:headers 				= "header_table"
								:items 					= "render_list"
								class 					= "elevation-5"
								:options.sync 			= "options"
							   	:server-items-length 	= "total"
							   	:footer-props 			= "{
							   		showFirstLastPage 	: true,
							   		itemsPerPageOptions : [15, 30],
							   		showCurrentPage 	: true,
							   		itemsPerPageText 	: ''
							   	}"
							   	loading-text 			= "Loading... Please wait"
							   	:loading 				= "loading"
							    item-key 				= "index"
							    :height 				= "layout_height + 'px'"
							>
							    <!-- rowsPerPageText: [30] -->
								<template v-slot:item.actions = "{ item }" >
									<v-btn
										x-small
										color  = "primary"
										@click = "redirect('listing_setting', item)"
										v-show = "show.edit_list"

									>
										<v-icon
											x-small
											v-text = "'mdi-pencil'"
										></v-icon>
									</v-btn>	
									<v-btn
										x-small
										color  = "error"
										class  = "mx-1"
										@click = "actions('confirm_delete', item)"
										v-show = "show.delete_list"
									>
										<v-icon
											x-small
											v-text = "'mdi-delete'"
										></v-icon>
									</v-btn>							
								</template>
								<template v-slot:item.actionss = "{ item }" >
									<v-btn
										x-small
										v-for  = "(item_btn, idx_btn) of item.actionss"
										:key   = "idx_btn"
										:color = "item_btn.active ? 'primary' : 'secondary'"
										
									>
										<v-icon
											x-small
										>
											{{ item_btn.icon }}
										</v-icon>
									</v-btn>
								</template>
								<template v-slot:item.analytic = "{ item }" >
										<!-- x-small -->
									<span  
										v-for = "(item_analytic, idx_analytic, key_analytic ) of item.analytic"
										:key  = "idx_analytic"
										v-if  = "idx_analytic < 2"
									>	
										
									 	{{ item_analytic.text + ', ' }}									 									
										{{ idx_analytic > 2 ?  ' ( ' + item_analytic.length - 2 + ')' : '' }} 
									</span>
								</template>
								<template
									v-slot:item.type = "{ item }"
								>
									<v-chip
										x-small
										class = "text-uppercase"
										:color = " item.type == 'lpr' ? '' : 'primary'" 
									>
										{{ item.type }}
									</v-chip>
								</template>
							</v-data-table>

						</v-col>
					</v-row>
				</v-card-text>
			</v-card>
		</v-col>
	</v-row>
</template>
<script>
	import EventBus from '@/event-bus'

	export default {	
		name : 'add_list',
		data : (vm) => ({
			info 		 : {},
			header_table : [
				{ text : vm.$ml.get('id'), value: 'id' },				
				{ text : vm.$ml.get('name'), value: 'name' },				
				{ text : vm.$ml.get('type'), value: 'type' },
				{ text : vm.$ml.get('description'), value: 'description' },
				
				{ text : vm.$ml.get('actions'), value: 'actions' },
				// { text: vm.$ml.get('options'), value: 'options' },
				,				
			],
			options 	  : { itemsPerPage : 30},
			total 		  : 1,
			layout_height : 500,
			option_lists  : [
				{ 
					title 	: 'New list', 
					key 	: 'new',
					color 	: 'primary', 
					enable 	: true, 
					btn_action : 'new_list', 
					icon 		: 'mdi-playlist-plus'
				},
			
			],
			list  	: [],
			loading : false,
			show 	: {
				add_list  	: true,
				edit_list 	: true,
				delete_list : true,
			}
		}), // data

		created(){
			if (this.$route && this.$route.name) {

				if (!this.$store.getters["auth/permission"]( this.$route.name || "lists", "can_add", "lists")) {
					this.show.add_list = false;
				}
				if (!this.$store.getters["auth/permission"]( this.$route.name || "lists", "can_edit", "lists")) {
					this.show.edit_list = false;
				}
				if (!this.$store.getters["auth/permission"]( this.$route.name || "lists", "can_delete", "lists")) {
					this.show.delete_list = false;
				}
			}
		}, // created

		watch:{
			options: {
				handler(){
					this.get_list();
				}, deep: true,
			}, // options

		}, // watch

		methods: {
			actions(act, item){
				if ( act == 'confirm_delete' ) {
					this.info = item;
					EventBus.$emit('notifications_modal', {
						type : 'confirm_delete',
						ID   :  'lists',  
					})
				}
				if ( act == 'delete' ) {
					this.delete();
				}

			}, // actions

			get_list(){
				const { itemsPerPage, page } = this.options;
				let pg = 1, sw = 0;
				let vm = this;
				this.loading = true;

				if ( itemsPerPage == 15 ) {
					if (page % 2 == 0) {
						pg = (page / 2);
						sw = 2;
					}else{
						pg = parseInt(page / 2) + 1;
						sw = 1;
					}
				}else{
					pg = page
				}
				const api = this.$URL + '/api/v1/list/?page=' + pg;
				
				this.$axios.get(api).then( res => {
					console.log(res, 'Get list');
					let items  = res.data.rows;

					this.total = parseInt(res.data.count);
					
					if (itemsPerPage <= 15) {
						items = items.slice((sw - 1) * itemsPerPage, sw  + itemsPerPage );
					}
					this.list = items;
					this.loading = false;

				}).catch(er => {
					console.log(er, 'Error get list');
					this.loading = false;

				});
			}, // get list
			delete(){
				let info_del = this.info;

				if (info_del && info_del.id) {
					const api = this.$URL + '/api/v1/list/' + info_del.id;

					this.$axios.delete( api ).then( res => {
						console.log(res, 'Delete res alarms');
						this.list.splice(this.list.indexOf(info_del), 1);
						this.total --;
						// this.save_local(true);
						EventBus.$emit('notifications_modal', {
							type : 'deleted'
						});
					}).catch( er => {
						console.log(er, 'Error delete alarms');
					})
				}
			}, // delete

			redirect(url, item){
				if (url == 'listing_setting') {
					console.log("clear alarms local ***************************************")
					localStorage.removeItem("listing_setting");
					localStorage.setItem("listing_setting", JSON.stringify(item));
				}
				const  timer = setTimeout( () => {
					this.$router.push(url);
					clearTimeout(timer);
				}, 50)
			}, // redirect

		}, // methods

		computed:{
			
			render_list: function(){
				return this.list;
			}, // render list

		}, // computed

		mounted(){
			
			EventBus.$on('notifications_modal' + 'lists', (action) =>{
				if (action) {
					this.actions('delete');
				}
			});

		}, // mounted

	}; // export default
</script>